import { useQuery } from '@tanstack/react-query';
import { userService, GetPaginatedUsersParams } from '@services/user';

export const useUsers = (params: GetPaginatedUsersParams) => {
  return useQuery({
    queryKey: ['users', 'paginated', params],
    queryFn: () => userService.getPaginatedUsers(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useUsers;